<template>
  <b-overlay :show="isAgencyConnecting" rounded="sm">
    <div class="campaigns-page d-flex">
      <div
        v-if="currentAgency && !isAgencyConnecting"
        class="campaigns-page--content px-2 py-2 px-md-4 py-md-4"
      >
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </div>
  </b-overlay>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import CampaignDashboard from "../components/dashboard/campaigns/CampaignDashboard.vue";
import NewConversationButton from "../components/action_buttons/NewConversationButton";
import NewRecordingButton from "../components/action_buttons/NewRecordingButton";
import NewNotificationButton from "../components/action_buttons/NewNotificationButton";

export default {
  name: "Campaigns",
  components: {
    CampaignDashboard,
    NewConversationButton,
    NewRecordingButton,
    NewNotificationButton,
  },
  computed: {
    ...mapGetters("agency", [
      "currentAgency",
      "agencySettings",
      "isAgencyConnecting",
    ]),
    ...mapGetters("campaigns", ["currentCampaign"]),
    showLeftSidebar() {
      return (
        this.currentAgency &&
        !this.isAgencyConnecting &&
        this.$auth.isAuthenticated
      );
    },
    showRightSidebar() {
      return this.currentAgency && !this.conversationStatus;
    },
  },
};
</script>


<style lang="scss">
.campaigns-page {
  width: 100%;
  height: 100%;
  &--content {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
